import { AdditionOptions } from "src/lib/ProblemGenerators/addition"
import { DivisionOptions } from "src/lib/ProblemGenerators/division";
import { MultiplicationOptions } from "src/lib/ProblemGenerators/multiplication";
import { SubtractionOptions } from "src/lib/ProblemGenerators/subtraction";
import { CombinedProblemConfigs } from "./CombinedProblemGenerator";

export type ProgressionConfigs = {
    progressionRate: number;

    addition: AdditionOptions & {
        include: boolean;
    },
    subtraction: SubtractionOptions & {
        include: boolean;
    },
    multiplication: MultiplicationOptions & {
        include: boolean;
    },
    division: DivisionOptions & {
        include: boolean;
    }
}
export const DefaultProgressionConfigs = {
    progressionRate: 5,
    addition: {
        include: true,
        maxResult: 5
    },
    subtraction: {
        include: false,
        operand1: {
            max: 5
        },
    },
    multiplication: {
        include: false,
        operand1: {
            max: 2
        },
        operand2: {
            max: 2
        }
    },
    division: {
        include: false,
        operand1: {
            max: 3
        },
        operand2: {
            max: 2
        }
    }
}

// convert the configs from ProgressionConfigs to a CombinedProblemGenerator configs
export function convertConfigs(pConfig: ProgressionConfigs) : CombinedProblemConfigs {
    let configsOut = {};
    let configCopy = structuredClone(pConfig) as any;

    console.log(pConfig)

    delete configCopy.addition.include;
    delete configCopy.subtraction.include;
    delete configCopy.multiplication.include;
    delete configCopy.division.include

    Object.assign(configsOut, { progressionRate: pConfig.progressionRate });

    // addition
    if (pConfig.addition.include) {
        Object.assign(configCopy.addition, { 
            frequency: pConfig.addition.include ? 1 : 0, progression: true, 
            operand1: { max: Math.round((configCopy.addition.maxResult*0.7)), min: Math.max(configCopy.addition.maxResult - 5, 0) }, 
            operand2: { max: configCopy.addition.maxResult }
        })   // set both operands to a max of the maxResult
        Object.assign(configsOut, { addition: configCopy.addition });
    } else {
        Object.assign(configsOut, { addition: { frequency: 0 }});
    }

    // subtraction
    if (!configCopy.subtraction.operand1)
        configCopy.subtraction.operand1 = {};
    if (!configCopy.subtraction.operand2)
        configCopy.subtraction.operand2 = {};
    Object.assign(configCopy.subtraction.operand1, { min: 1 });
    Object.assign(configCopy.subtraction.operand2, { min: 1 });
    Object.assign(configCopy.subtraction, { frequency: pConfig.subtraction.include ? 1 : 0, progression: true })
    Object.assign(configsOut, { subtraction: configCopy.subtraction } )  // same config structure in both

    // multiplication
    Object.assign(configCopy.multiplication.operand1, { min: 0 });
    Object.assign(configCopy.multiplication.operand2, { min: 0, max: configCopy.multiplication.operand1.max });
    
    Object.assign(configCopy.multiplication, { frequency: pConfig.multiplication.include ? 1 : 0, progression: true })
    Object.assign(configsOut, { multiplication: configCopy.multiplication });
    
    // division
    Object.assign(configCopy.division.operand1, { min: 1, max: configCopy.division.operand1.max });
    Object.assign(configCopy.division.operand2, { min: 1, max: configCopy.division.operand1.max });
    Object.assign(configCopy.division, { frequency: pConfig.division.include ? 1 : 0, progression: true });
    Object.assign(configsOut, { division: configCopy.division });


    return configsOut as CombinedProblemConfigs;
}